export default __webpack_public_path__ + "ae78e3b6bf26944047abd49d51508b24.png";